function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 49 50"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.08 29.06l-2.44-2.44a2.63 2.63 0 010-3.73L22.99 1.53a2.63 2.63 0 013.73 0L48.1 22.89a2.63 2.63 0 010 3.73l-2.44 2.44a2.64 2.64 0 01-3.77-.04L29.26 15.77v31.6A2.63 2.63 0 0126.62 50H23.1a2.63 2.63 0 01-2.63-2.64V15.77L7.85 29.02a2.62 2.62 0 01-3.77.04z"
})));